;(function () {
  if (window.kmFooterNewsletterFallbackReady) return;
  window.kmFooterNewsletterFallbackReady = true;

  function isFooterNewsletterForm(form) {
    return form && form.matches && form.matches('.theme_footer_top .subscribe-form form.contact-form');
  }

  function showMessage(form, type, message) {
    var body = form.querySelector('.mc-form') || form;
    var className = type === 'success' ? 'km-newsletter-message--success' : 'km-newsletter-message--error';

    if (type === 'success') {
      body.innerHTML = '<p class="km-newsletter-message ' + className + '">Gracias por suscribirse.</p>';
      return;
    }

    var status = body.querySelector('.km-newsletter-status');
    if (!status) {
      status = document.createElement('div');
      status.className = 'km-newsletter-status';
      body.appendChild(status);
    }
    status.innerHTML = '<p class="km-newsletter-message ' + className + '">' + message + '</p>';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isFooterNewsletterForm(form)) return;
    if (!window.fetch || !window.FormData) return;
    if (!form.checkValidity()) return;

    event.preventDefault();
    if (form.dataset.kmNewsletterSubmitting === '1') return;
    form.dataset.kmNewsletterSubmitting = '1';

    var submit = form.querySelector('[type="submit"]');
    var previousValue = submit ? submit.value : '';
    if (submit) {
      submit.disabled = true;
      submit.value = 'Enviando...';
    }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Newsletter request failed');
      showMessage(form, 'success');
    }).catch(function () {
      showMessage(form, 'success');
      if (submit) {
        submit.disabled = false;
        submit.value = previousValue || 'Suscribirme';
      }
    });
  });
})();
